// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import Footer from 'components/Footer/Footer'

// Redux:
import { closeMenu } from 'actions/site'
import { getPageData } from 'actions/page'

class Menu extends React.Component {
	handleMenuItemClick = ( e ) => {
		const { dispatch } = this.props

		setTimeout( () => {
			document.documentElement.classList.remove( 'with-site-menu-open' )

			dispatch( closeMenu() )
		}, 1000 )
	}

	handleMenuItemMouseOver = ( e ) => {
		const { dispatch } = this.props
		let slug = e.currentTarget.getAttribute( 'data-id' )

		if ( slug ) {
			dispatch(
				getPageData( {
					slug: slug,
					requestOnly: true
				} )
			)
		}
	}

	renderLink( item ) {
		let linkMarkup,
			extraClass = item.class ? item.class : ''

		if ( '/' === item.url ) {
			linkMarkup = (
				<Link to='/' exact className="button" activeClassName="is-active" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</Link>
			)
		} else if ( item.url.indexOf( '//' ) > -1 || item.url.indexOf( 'mailto:' ) > -1 ) {
			linkMarkup = (
				<a href={ item.url } className="button" target="_blank" onClick={ this.handleMenuItemClick }>
					{ item.title }
				</a>
			)
		} else {
			linkMarkup = (
				<Link
					to={ item.url }
					fuzzyMatch={ true }
					className={ `button ${extraClass}` }
					activeClassName="is-active"
					onClick={ this.handleMenuItemClick }
					onMouseOver={ this.handleMenuItemMouseOver }
					data-id={ item.url }
				>
					{ item.title }
				</Link>
			)
		}

		return linkMarkup
	}

	render() {
		const { data, menuIsOpen, accountData, addedIds, className, isMobile } = this.props
		const wrapClass = menuIsOpen ? `on-mobile-is-active menu-wrap ${className}` : `menu-wrap ${className}`
		var menuItemsMarkup = ''

		if ( data && Object.keys( data ).length ) {
			menuItemsMarkup = Object.keys( data )
				.map( ( key ) => {
					// Top level:

					let e = data[ key ],
						childrenMarkup = '',
						linkMarkup = this.renderLink( e )

					if ( e.children && Object.keys( e.children ).length ) {
						// Children:

						let childrenItemsMarkup = Object.keys( e.children )
							.map( ( key ) => {
								let childLinkMarkup = this.renderLink( e.children[ key ] )

								return (
									<li key={ key }>
										{ childLinkMarkup }
									</li>
								)
							} )

						childrenMarkup = (
							<div className="-dropdown">
								<ul>
									{ childrenItemsMarkup }
								</ul>
							</div>
						)
					}

					return (
						<li key={ key }>
							{ linkMarkup }
							{ childrenMarkup }
						</li>
					)
				} )
		}

		return (
			<div className={ wrapClass }>
				<div id="site_menu" className="-menu">
					<ul>
						{ isMobile &&
							<li className="-mobile-menu-heading">Menu</li>
						}

						{ menuItemsMarkup }
					</ul>

					{ isMobile &&
						<Footer isMobileMenu={ true } />
					}

					{/*<div className="-social">
						<a href={ siteData.facebook_url } target="_blank" rel="noopener">
							<span className="u-screen-reader-text">Facebook</span>
							<i className="icon-facebook-square" arua-hidden="true"></i>
						</a>

						<a href={ siteData.instagram_url } target="_blank" rel="noopener">
							<span className="u-screen-reader-text">Instagram</span>
							<i className="icon-instagram" arua-hidden="true"></i>
						</a>
					</div>*/}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		menuIsOpen: state.site.menuIsOpen
	}
}

export default connect( mapStateToProps )( Menu )



// WEBPACK FOOTER //
// ./components/menu/menu.jsx